export const defaultStyles = {
  alignment: "center",
  backgroundColor: "var(--theme-email-secondary-button-background-color)",
  borderColor: "var(--theme-email-secondary-button-border-color)",
  borderRadius: {
    border_left_top_radius:
      "var(--theme-email-secondary-button-border-left-top-radius)",
    border_left_bottom_radius:
      "var(--theme-email-secondary-button-border-left-bottom-radius)",
    border_right_top_radius:
      "var(--theme-email-secondary-button-border-right-top-radius)",
    border_right_bottom_radius:
      "var(--theme-email-secondary-button-border-right-bottom-radius)",
  },
  borderWidth: "var(--theme-email-secondary-button-border-width)",
  color: "var(--theme-email-secondary-button-text-color)",
  fontFamily: "var(--theme-email-secondary-button-font-family)",
  fontSize: "var(--theme-email-secondary-button-font-size)",
  fontStyle: "normal",
  fontWeight: "var(--theme-email-secondary-button-font-weight)",
  letterSpacing: "var(--theme-email-secondary-button-letter-spacing)",
  lineHeight: "var(--theme-email-secondary-button-line-height)",
  textAlign: "center",
  textDecoration: "none",
  textTransform: "none",
  sizing: {
    width: "auto",
    height: "auto",
    minWidth: "auto",
    minHeight: "auto",
    maxWidth: "auto",
    maxHeight: "auto",
  },
  padding: {
    paddingTop: "var(--theme-email-secondary-button-padding-top)",
    paddingBottom: "var(--theme-email-secondary-button-padding-bottom)",
    paddingLeft: "var(--theme-email-secondary-button-padding-left)",
    paddingRight: "var(--theme-email-secondary-button-padding-right)",
  },
  margin: {
    marginTop: "12",
    marginBottom: "12",
    marginLeft: "24",
    marginRight: "24",
  },
} as const;
